import { format, parseISO } from 'date-fns';
import { ar, enGB } from 'date-fns/locale';
import { config } from '@/config';

const locales = { en: enGB, ar } as const;
const localeOf = (code: string) => locales[code as keyof typeof locales] ?? enGB;

export function formatDate(value: string | Date | null | undefined, locale: string) {
  if (!value) return '—';
  const date = typeof value === 'string' ? parseISO(value) : value;
  return format(date, config.dateFormat, { locale: localeOf(locale) });
}

export function formatTime(value: string | Date | null | undefined, locale: string) {
  if (!value) return '—';
  const date = typeof value === 'string' ? parseISO(value) : value;
  return format(date, config.timeFormat, { locale: localeOf(locale) });
}

/** 495 -> "8h 15m". Duration, not clock time. */
export function formatMinutes(minutes: number | null | undefined) {
  if (minutes == null) return '—';
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return h ? `${h}h ${m}m` : `${m}m`;
}

export function formatSeconds(seconds: number) {
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = seconds % 60;
  return [h, m, s].map((n) => String(n).padStart(2, '0')).join(':');
}

export const toIsoDate = (date: Date) => date.toISOString().slice(0, 10);
